import React from 'react'
import { Button } from '@mui/material';
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import Typography from '@mui/joy/Typography';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { useState } from 'react';
import CheckIcon from '@mui/icons-material/Check';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import ClearIcon from '@mui/icons-material/Clear';
import "../ContentSeo/TitleDivSeo.css"

function Have404Page(props) {



    const [open, setOpen] = useState(false);
    const handleClickOpen = () => {
        setOpen(true);
      };
    
      const handleClose = (e) => {
        setOpen(false);
      }



  return (
    <div id={`section-${props.index}`}>
      <div style={{marginTop:"10px"}} className='TitleDivSeo' onClick={handleClickOpen}>
      <div className="CARD" onClick={handleClickOpen}>
       <div
        style={{
          background: 'linear-gradient(to right, #ffcc00, #ff9900)', // Use your preferred background style
          padding: '10px',
          borderRadius:"5px",
          opacity:"0.6",
          color:"white"
        }}
      >
        <h3>صفحة الخطأ 404 </h3>
      </div>
       <Card orientation="horizontal" variant="outlined" sx={{ width: "100%",textAlign:"right"}}>
      <CardContent>
        <Typography fontWeight="md" textColor="success.plainColor">
            {props.CheckPage404 === true ? "جيد لديك صفحة خطأ 404 خاصة بك " :
             "أوبس ليس لديك صفحة خطأ خاصة بك"}
        </Typography>

  <Typography fontWeight="md" level="body-sm">
    <a target="_blank" href={props.nonExistentPageUrl}>
    {props.nonExistentPageUrl}
    </a>
</Typography>
</CardContent>
{ props.CheckPage404 ?
  <CheckIcon style={{ color: "#27ae60", fontSize: "50px" }} /> : 
  <PriorityHighIcon style={{ color: "#f39c12",fontSize: "50px" }} /> }
    </Card>
    </div>
    <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent style={{direction:"rtl"}}>
          <DialogContentText id="alert-dialog-description" style={{color:"rgb(78, 181, 76)"}}>
          عندما يواجه الزائر خطأ 404 File Not Found على موقعك ، فأنت على وشك فقدان الزائر الذي عملت بجد للحصول عليه من خلال محركات البحث وروابط الجهات الخارجية.
يتيح لك إنشاء صفحة خطأ 404 المخصصة تقليل عدد الزوار المفقودين بهذه الطريقة.
          </DialogContentText>
        </DialogContent>
        <Button onClick={(e) => { e.stopPropagation(); handleClose(); }}>close</Button>
      </Dialog>
    </div>
    </div>
  )
}
export default Have404Page